import { getJobApiCall, postJobApiCall } from "../../utils/jobRequest";
import { handle403Logout } from "../../utils/request";
import { GET_CALL_PER_DAY, GET_CATEGORY_SUMMARY, GET_ENGAGEMENTS, GET_RECENT_CALL_DETAILS, GET_RECENT_CALLS } from "../Types/types";
import { returnErrors } from "./errorAction";

//Interview Summary
export const getCategorySummary = (obj) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`event-metrics/category-summary`, obj);
    if (response?.status === 200) {
      dispatch({type: GET_CATEGORY_SUMMARY ,payload: response.data});
      return response.data;
    } else {
      returnErrors(dispatch,response?.data?.responseMessages?.[0]?.message,response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages?.[0]?.message,error?.response?.status);
  }
};

//Interview calls per day
export const getInterviewCallsPerDay = (obj) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`event-metrics/calls-per-day`, obj);
        if (response?.status === 200){
            dispatch({ type: GET_CALL_PER_DAY, payload: response.data });
            return response.data;
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch,error.response?.data?.responseMessages?.[0]?.message,error?.response?.status);
    }
}

//Recent Calls
export const getRecentCalls = (obj) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`event-metrics/recent-calls`, obj);
    if (response?.status === 200) {
      dispatch({ type: GET_RECENT_CALLS, payload: response.data})
      return response.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages?.[0]?.message,error?.response?.status);
  }
}

//Recent Call details
export const getRecentCallDetails = (obj) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`event-metrics/recent-call-details`, obj);
    if (response?.status === 200) {
      dispatch({ type: GET_RECENT_CALL_DETAILS, payload: response.data})
      return response.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages?.[0]?.message,error?.response?.status);
  }
}

//engagements
export const getEngagements = (params) => async (dispatch) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const response = await getJobApiCall(`event-metrics/engagements?${queryString}`);
    if (response?.status === 200) {
      dispatch({ type: GET_ENGAGEMENTS, payload: response.data });
      return response.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages?.[0]?.message,error?.response?.status);
  }
}